import { type DependencyList, type EffectCallback, useEffect } from 'react';

import type { EqualFunction } from './types';

import { useCompareMemoize } from './hooks';

/**
 * A hook that works like `useEffect`, but compares dependencies using a custom equality function.
 *
 * @param effect - The effect callback to run.
 * @param dependencies - The dependencies array to compare.
 * @param equals - The equality function to use for comparing dependencies.
 */
export const useCompareEffect = (
  effect: EffectCallback,
  dependencies: DependencyList,
  equals: EqualFunction<DependencyList>
) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies: the dependencies are memoized using useCompareMemoize
  useEffect(effect, useCompareMemoize(dependencies, equals));
};
